<!--
 * @Description: 酒店详情
 * @Author: wjh
 * @Date: 2021-3
 * @LastEditors: wjh
 -->
<template>
    <div id="hotelList">
        <Loading v-if="show"></Loading>
        <div class="hotelList_container">
            <header class="hotel-header">
                <div class="header-left" @click="goBack">
                    <div class="header-cricle">
                        <img src="../../assets/return-white.png">
                    </div>
                </div>
                <div class="header-title">
                </div>
                <div class="header-right">
                    <div class="header-cricle">
                        <img src="../../assets/share.png">
                    </div>
                </div>
            </header>
            <div class="hotelList_content">
                <!-- <div class="hotel-banner" v-if="hotelAllInfos.hotelpicList!=null&&hotelAllInfos.hotelpicList.length>0">
                    <swiper :options="swiperOption" ref="mySwiper">
                        <div class="swiper-slide" v-for="(item,index) in hotelAllInfos.hotelpicList" :key='index'>
                            <img :src="item" alt />
                        </div>
                        <div class="swiper-pagination" slot="pagination"></div>
                    </swiper>
                </div> -->
                <div class="swiper-container hotel-banner hotel-banners" v-if="hotelAllInfos.hotelpicList!=null&&hotelAllInfos.hotelpicList.length>0">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide"
                       v-for="(item,index) in hotelAllInfos.hotelpicList" :key='index'>
                        <img :src="item" alt />
                    </div>
                  </div>
                  <div class="pagination"></div>
                </div>
                <div class="hotel-banner" v-else>
                    <img v-if="meetingInfo.MobileBannerImage!=null&&meetingInfo.MobileBannerImage!=''&&meetingInfo.MobileBannerImage" :src="meetingInfo.MobileBannerImage" alt />
                    <img v-else src="../../assets/activity.jpg">
                </div>
                <div class="hotel-detail-name">
                    {{hotelAllInfos.hotellname}}
                </div>
                <div class="hotel-wrap" style="flex-direction: column;">
                    <div class="hotel-server">
                        <div class="hotel-address">
                            <p class="hotal-syq">{{changeDate(hotelAllInfos.openingdate,4)}}年开业
                                {{changeDate(hotelAllInfos.lastrenovation,4)}}年装修</p>
                        </div>
                        <div class="hotel-btn" @click="getServices()">
                            <div class="hotel-tag">
                                <img src="../../assets/server.png">
                            </div>
                            详情/电话
                            <img src="../../assets/arrow-b.png" v-if="!serShowMore">
                            <img src="../../assets/arrow-t.png" v-if="serShowMore">
                        </div>
                    </div>
                    <div class="services" v-if="!serShowMore">
                        <div class="service-row">
                            <div class="service-label">酒店服务设施</div>
                            <div class="service-text">
                                <span v-for="(item,index) in hotelAllInfos.hotelservicesinfo" :key='index'>
                                    <img src="../../assets/yes.png">{{item}}
                                </span>
                            </div>
                        </div>
                        <div class="service-row">
                            <div class="service-label">会议服务设施</div>
                            <div class="service-text">
                                <span v-for="(item,index) in hotelAllInfos.meetingservicesinfo" :key='index'>
                                    <img src="../../assets/yes.png">{{item}}
                                </span>
                            </div>
                        </div>
                        <div class="service-row">
                            <div class="service-label">客房服务设施</div>
                            <div class="service-text">
                                <span v-for="(item,index) in hotelAllInfos.guestroomservicesinfo" :key='index'>
                                    <img src="../../assets/yes.png">{{item}}
                                </span>
                            </div>
                        </div>
                        <div class="service-row">
                            <div class="service-label">餐饮服务设施</div>
                            <div class="service-text">
                                <span v-for="(item,index) in hotelAllInfos.hotelrestaurantinfo" :key='index'>
                                    <img src="../../assets/yes.png">{{item}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="services-more" v-if="serShowMore">
                        <div class="service-row">
                            <div class="service-label">酒店服务设施</div>
                            <div class="service-text">
                                <span v-for="(item,index) in hotelAllInfos.hotelservicesinfo" :key='index'>
                                    <img src="../../assets/yes.png">{{item}}
                                </span>
                            </div>
                        </div>
                        <div class="service-row">
                            <div class="service-label">会议服务设施</div>
                            <div class="service-text">
                                <span v-for="(item,index) in hotelAllInfos.meetingservicesinfo" :key='index'>
                                    <img src="../../assets/yes.png">{{item}}
                                </span>
                            </div>
                        </div>
                        <div class="service-row">
                            <div class="service-label">客房服务设施</div>
                            <div class="service-text">
                                <span v-for="(item,index) in hotelAllInfos.guestroomservicesinfo" :key='index'>
                                    <img src="../../assets/yes.png">{{item}}
                                </span>
                            </div>
                        </div>
                        <div class="service-row">
                            <div class="service-label">餐饮服务设施</div>
                            <div class="service-text">
                                <span v-for="(item,index) in hotelAllInfos.hotelrestaurantinfo" :key='index'>
                                    <img src="../../assets/yes.png">{{item}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="hotel-wrap">
                    <div class="hotel-address">
                        <!-- <p class="hotal-syq">商业圈</p> -->
                        <p>{{hotelAllInfos.hoteladdress}}</p>
                    </div>
                    <div class="hotel-btn" @click="goMap()">
                        <div class="hotel-tag">
                            <img src="../../assets/add.png">
                        </div>
                        地图<img src="../../assets/arrow-r.png">
                    </div>
                </div>
                <div class="hotel-wraps">
                    <div class="guests-infos">
                        <div class="guests-info">
                            <div class="guests-day">
                                <!-- <input :value="dateRange" @click="showCalendar" readonly type="text" class="input-wrap" placeholder="点击唤起日历组件" /> -->
                                <div class="rangediv" v-html="dateRange" @click="showCalendar" ></div>
                            </div>
                            <!-- <div class="guests-number">
                                <input v-model="roomNum" type="text" @change="regCheck($event)"/>间 · 
                                <input v-model="peopleNum" type="text" @change="regCheck1($event)"/>人
                            </div> -->
                            <hotel-calendar ref="hotelCalendar" :key="time" :visibility="calendarShow" @select-date-range="selectDateRangeHandle" 
                                :show-month="4" 
                                format="YYYY-MM-DD" 
                                @select-date-sure="selectDateSure" 
                                @select-date-close="selectDateClose" 
                                :initDate="initDate"
                                :minRangeDate="minRangeDate"
                                :maxRangeDate="maxRangeDate"></hotel-calendar>
                        </div>
                    </div>
                    <div class="guests-infoss">
                        <div class="guests-choose">
                            <div class="choose-span" v-for="(item,index) in roomType" 
                            :class="{'roomActive':roomActive==index}"
                            @click="getHrtType($event,item,index)"> 
                                {{item}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="hotel-room">
                    <div class="hotel-list" v-for="(item,index) in hotelAllInfos.HotelRoomTypeEntity" :key='index'>
                    <!-- <div class="hotel-list" :class="{'hotelNo':item.lastnum==0}" v-for="(item,index) in hotelAllInfos.HotelRoomTypeEntity" :key='index'> -->
                        <div class="hotel-img">
                            <img v-if="(item.RoomPic==''||item.RoomPic==null||!item.RoomPic)&&
                            (hotelAllInfos.hotelpicList==null||hotelAllInfos.hotelpicList==''||!hotelAllInfos.hotelpicList)" src="../../assets/hotel.png">
                            <img v-if="(item.RoomPic==''||item.RoomPic==null||!item.RoomPic)&&
                            (hotelAllInfos.hotelpicList!=null&&hotelAllInfos.hotelpicList!='')" :src="hotelAllInfos.hotelpicList[0]">
                            <img v-else :src="item.RoomPic">
                        </div>
                        <div class="hotel-con">
                            <div class="hotel-name" @click="getRoomInfo($event,item)">
                                {{item.showname}}<img src="../../assets/arrow-r.png">
                            </div>
                            <div class="hotel-desc">
                                <p v-if="item.isbreakfast==0">无餐食</p>
                                <p v-else>
                                    <span v-if="item.breakfasttype==0">单份早餐</span>
                                    <span v-else>双份早餐</span>
                                </p>
                            </div>
                            <!-- <div class="hotel-lastnum">
                                房间仅剩{{item.lastnum}}间
                            </div> -->
                            <div class="hotel-money">
                                <span>￥{{item.money}}</span> 起
                                <div class="room-btn" @click="goOrder($event,item.showname,item.hrtid,item.showname,item.money,item.reservatcount)">
                                    订
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="hotel-wraps">
                    <div class="hotel-text-tit">
                        订单必读
                    </div>
                    <div class="hotel-text">
                        <p>{{(hotelAllInfos.hotelremark==null||hotelAllInfos.hotelremark=='')?'暂无':hotelAllInfos.hotelremark}}</p>
                    </div>
                </div> -->
                <div class="hotel-rooms" v-if="otherHotel!=null">
                    <div class="hotel-text-tit">
                        其他酒店
                    </div>
                    <div class="hotel-list" v-for="(item,index) in otherHotel" :key='index' @click="goDetail($event,item.hotelid)">
                        <div class="hotel-img">
                            <img v-if="item.hotelpic==''||item.hotelpic==null||!item.hotelpic" src="../../assets/hotel.png">
                            <img v-else :src="item.hotelpic">
                        </div>
                        <div class="hotel-con">
                            <div class="hotel-name">
                                {{item.hotellname}}
                            </div>
                            <div class="hotel-desc">
                                距离会场直线距离{{item.venuedistance}}米
                            </div>
                            <div class="hotel-money">
                                <span>￥{{item.money}}</span> 起
                            </div>
                            <div class="hotel-btn">
                                <!-- <span>健康守护</span> -->
                                <span @click="goDetail($event,item.hotelid)">立即预定</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="hotel-wraps">
                    <div class="hotel-detail-btn">
                        <div class="hotel-detail-index">
                            首页
                        </div>
                        <div class="hotel-detail-order" @click="goOrder">
                            立即预定
                        </div>
                    </div>
                </div> -->
                <div class="loading" v-if="loading">
                    <van-loading type="spinner" color="#3b82f6" vertical size="30px" text-size="14px">加载中...</van-loading>
                </div>
            </div>
            <div class="room-ups" v-if="roomInfoShow">
                <div class="room-ups-bg"></div>
                <div class="room-ups-content">
                    <div class="swiper-container room-banners" v-if="roomInfos.RoomImgs!=null&&roomInfos.RoomImgs.length>0">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide"
                                v-for="(item,index) in roomInfos.RoomImgs" :key='index'>
                                <img :src="item" alt />
                            </div>
                        </div>
                        <div class="pagination"></div>
                    </div>
                    <div class="room-ups-close" @click="closeRoomInfo()">
                        <img src="../../assets/close.png">
                    </div>
                    <div class="room-infos">
                        <div class="room-infos-title">
                            {{roomInfos.hrtname}}
                        </div>
                        <div class="room-infos-con">
                            <span>可入住人数: {{roomInfos.canpeople}}</span>
                            <span>剩余房间数: {{roomInfos.lastnum}}</span>
                        </div>
                        <div class="room-infos-notes">
                            订单必读: 
                            <div v-if="hotelAllInfos.hotelremark==null||hotelAllInfos.hotelremark==''">
                                <p >暂无</p>
                            </div>
                            <div v-else>
                                <p v-for="(item,index) in hotelAllInfos.hotelremark">
                                    {{item}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Loading from '@components/Loading.vue'
import Footer from '@components/Footer.vue'
import publicSignup from '../../lib/signUp.js'
import wxShare from '../../lib/wxShare.js'
import hotelCalendar from 'vue-hotel-calendar'
import { swiper, swiperSlide } from "vue-awesome-swiper"
export default {
    name: 'hotelDetail',
    components: {
        Loading,
        hotelCalendar,
        swiper,
        swiperSlide
    },
    data() {
        return {
          publicSignup: {}, //通用js
          params: {
              m: '',
              hotelid: '',
          },
          meetingInfo: '',
          show: false,
          loading: false,
          red: '',
          navShow: true,
          navhomeUrl: '',
          calendarShow: false,
          initDate: {
            startDate: '',
            initDate: '',
          },
          // initStartDate: '',
          // initEndDate: '',
          dateRange: '',
          dateRangeNum: 1,
          time: '',
          hotelAllInfos: [],
          serShowMore: false,
          swiperOption:{
            observer: true,
            observeParents: true,
            loop: true,
            autoplay: {
              delay: 3000,
              stopOnLastSlide: false,
              disableOnInteraction: true,
            },
            pagination: {
              el: '.swiper-pagination',
              type: 'bullets'
            },
          },
          otherHotel: [],
          roomType: [],
          roomHrtname: '',
          roomActive: -1,
          maxRangeDate: '',
          minRangeDate: '',
          roomNum: 1,
          peopleNum: 1,
          roomInfoShow: false,
          roomInfos: {},
          lats: {},
          address: '',
          headRess: '',
        }
    },
    created() {
        this.params = this.$route.query
        this.red = this.params.red
        this.publicSignup = new publicSignup()
        console.log(this.publicSignup)
        let opt = { m: this.params.m }
        var date = new Date();
        var day2 = new Date();
            day2.setTime(day2.getTime() + 24*60*60*1000);
        this.initDate.startDate = this.getDate(date)
        this.initDate.endDate = this.getDate(day2)
        this.dateRange = '<div class="rangedate" style="margin: 0 10px; border: 1px solid #e2e8f0;padding: 0 5px;border-radius: 5px;">'+this.initDate.startDate+'</div>' + '共1晚' + '<div class="rangedate" style="margin: 0 10px; border: 1px solid #e2e8f0;padding: 0 5px;border-radius: 5px;">'+this.initDate.endDate+'</div>'
        this.dateRangeNum = 1
        let opts = { 
            m: this.params.m, 
            hotelid: this.params.hotelid,
        }
        this.hotelInsidePage(opts)
    },
    mounted(){
        this.swiperInit()
        this.swiperInits()
        var e = this.$refs.hotelCalendar.getValue()
        this.selectDateRangeHandle(e)
        document.title = this.hotelAllInfos.hotellname
    },
    methods: {
        swiperInit() {
          this.$nextTick(function() {
            var bannerSwiper = new Swiper('.hotel-banners', {
              autoplay: {
                delay: 5000,
                stopOnLastSlide: false,
                disableOnInteraction: true,
              },
              loop: true,
              pagination: {
                el: '.pagination',
              }
            })
          })
        },
        getDate(date){
            var year = date.getFullYear(),
                month = date.getMonth() + 1,
                day = date.getDate(),
                month = month >= 10 ? month : '0' + month,
                day = day >= 10 ? day : '0' + day;
            return year + '-' + month + '-' + day
        },
        //时间转换
        changeDate(date,num){
            if( date != '' && date != null && date){
                var dateNew = date.substring(0, num)
                return dateNew.replace(new RegExp("/","gm"),"-")
            }

        },
        // swiperInit() {
        //     var banner = document.querySelector(".hotel-banner");
        //     new window.Swiper(banner, {// eslint-disable-line no-unused-vars
        //         autoplay: {
        //             delay: 3000,
        //             stopOnLastSlide: false,
        //             disableOnInteraction: true,
        //         },
        //         pagination: {
        //             el: '.swiper-pagination',
        //         },
        //         observer: true,
        //         observeParents: true,
        //         loop: true,
        //     })
        // },
        // async initmeeting(opt) {
        //     this.show = true
        //     this.meetingInfo = await this.publicSignup.init(opt, this)
        //     if (this.meetingInfo.Code === 1000) {
        //         this.show = false
        //         if (this.meetingInfo.HomeUrl == null || this.meetingInfo.HomeUrl == '') {
        //             this.navShow = false
        //         } else {
        //             this.navShow = true
        //             this.navhomeUrl = this.meetingInfo.HomeUrl
        //         }
        //     } else {
        //         this.$notify({
        //             massage: this.meetingInfo.Msg,
        //             type: 'danger',
        //             duration: '3000',
        //         })
        //     }
        // },
        /**
         * 初始化酒店数据
         */
        async hotelInsidePage(opts) {
            try {
                this.loading = true
                let res = await this.$http.hotelInsidePage(opts)
                console.log(res)
                if (res.Code === 1000) {
                    this.loading = false
                    this.hotelAllInfos = res.hotel_BasicinfoEntity
                    this.otherHotel = res.hotel_BasicinfoEntities
                    this.roomType = res.screen
                    this.address = this.hotelAllInfos.hoteladdress
                    this.initMap(this.address)
                    document.title = this.hotelAllInfos.hotellname
                    let checkstarttime = res.hotel_BasicinfoEntity.checkstarttime
                    let checkouttime = res.hotel_BasicinfoEntity.checkouttime
                    // let checkstarttime = ''
                    //let checkouttime = ''
                    let date,day2
                    if( checkstarttime == '' || checkstarttime == null ){
                        date = new Date();
                        this.minRangeDate = this.getDate(date)
                        day2 = new Date();
                        day2.setTime(day2.getTime() + 24*60*60*1000);
                    }else{
                        this.minRangeDate = this.changeDate(checkstarttime,10)
                        if( Date.parse(new Date()) > Date.parse(new Date(this.minRangeDate))){
                            date = new Date();
                            day2 = new Date();
                            day2.setTime(day2.getTime() + 24*60*60*1000);
                        }else{
                            date = new Date(this.changeDate(checkstarttime,10));
                            day2 = new Date(this.changeDate(checkstarttime,10));
                                day2.setTime(day2.getTime() + 24*60*60*1000);
                        }
                    }
                    //console.log(date,day2)
                    this.initDate.startDate = this.getDate(date)
                    this.initDate.endDate = this.getDate(day2)
                    this.dateRange = '<div class="rangedate" style="margin: 0 10px; border: 1px solid #e2e8f0;padding: 0 5px;border-radius: 5px;">'+this.initDate.startDate+'</div>' + '共1晚' + '<div class="rangedate" style="margin: 0 10px; border: 1px solid #e2e8f0;padding: 0 5px;border-radius: 5px;">'+this.initDate.endDate+'</div>'
                    
                    if( checkouttime == '' || checkouttime == null ){
                        this.maxRangeDate = '2100-12-31'
                    }else{
                        this.maxRangeDate = this.changeDate(checkouttime,10)
                    }
                    //console.log(this.initDate.startDate,this.initDate.endDate)
                    this.dateRangeNum = 1
                    this.$nextTick(function() {
                        this.swiperInit()
                        // var e = this.$refs.hotelCalendar.getValue()
                        // this.selectDateRangeHandle(e)  
                    })
                    const headRes = await this.$http.csData({
                      url: encodeURIComponent(
                        window.location.href.replace(location.hash, '')
                      )
                    })
                    console.log(headRes, 'headRes')
                    const _Wx = new wxShare({
                      opt: headRes
                    })
                    this.headRess = _Wx
                } else {
                    this.$notify({
                        message: res.Msg,
                        type: 'primary',
                    })
                }
            } catch (err) {
                console.log(err)
            }
        },

        getHrtType(e,hrtname,index){
            this.roomHrtname = hrtname
            let opts
            if( this.roomActive == index){
                this.roomActive = -1
                opts = { 
                    m: this.params.m, 
                    hotelid: this.params.hotelid,
                }
            }else{
                this.roomActive = index
                opts = { 
                    m: this.params.m, 
                    hotelid: this.params.hotelid,
                    hrtname: hrtname
                }
            }
            this.hotelInsidePage(opts)
        },
        getServices(){
            this.serShowMore = !this.serShowMore
        },

        //微信分享
        async initShare(title, desc, link, imgUrl) {
            try {
                const headRes = await this.$http.csData({
                    url: encodeURIComponent(
                        window.location.href.replace(location.hash, '')
                    ),
                })
                console.log(headRes, 'headRes')
                const _Wx = new wxShare({
                    opt: headRes,
                })
                _Wx.ready().then((wx) => {
                  _Wx.share(title, desc, link, imgUrl)
                  console.log(wx)
                })
                this.headRess = _Wx
            } catch (err) {
                console.log(err)
            }
        },

        showCalendar() {
            this.calendarShow = true;
            this.time = new Date().getTime()

        },
        selectDateRangeHandle(e) {
            var starttime = Date.parse(new Date(this.minRangeDate));
            var endtime = Date.parse(new Date(this.maxRangeDate));
            var starttimeSelect = Date.parse(new Date(e.startDate));
            var endtimeSelect = Date.parse(new Date(e.endDate));
            this.calendarShow = false;
            //this.dateRange = `${e.startDate} 共${e.seletDays - 1}晚 ${e.endDate}`
            this.dateRange = '<div class="rangedate" style="margin: 0 10px; border: 1px solid #e2e8f0;padding: 0 5px;border-radius: 5px;">'+`${e.startDate}`+'</div>' + `共${e.seletDays - 1}晚` + '<div class="rangedate" style="margin: 0 10px; border: 1px solid #e2e8f0;padding: 0 5px;border-radius: 5px;">'+`${e.endDate}`+'</div>'
            this.dateRangeNum = e.seletDays - 1
            this.initDate.startDate = e.startDate
            this.initDate.endDate = e.endDate
        },
        selectDateSure(e) {
            console.log(e)
            this.calendarShow = false;
            this.dateRange = '<div class="rangedate" style="margin: 0 10px; border: 1px solid #e2e8f0;padding: 0 5px;border-radius: 5px;">'+`${e.startDate}`+'</div>' + `共${e.seletDays - 1}晚` + '<div class="rangedate" style="margin: 0 10px; border: 1px solid #e2e8f0;padding: 0 5px;border-radius: 5px;">'+`${e.endDate}`+'</div>'
            this.dateRangeNum = e.seletDays - 1
            this.initDate.startDate = e.startDate
            this.initDate.endDate = e.endDate
            this.minRangeDate = e.startDate
            this.maxRangeDate = e.endDate
        },
        selectDateClose(){
            this.calendarShow = false;
        },
        goDetail(e,hotelid){
            const params = {
                m: this.params.m,
                hotelid: hotelid,
            }
            this.$router.push({
                path: '/hotelDetail',
                query: params,
            })
        },
        goBack(){
            this.$router.push({
                path: '/hotelList',
                query: {
                    m: this.params.m,
                }
            })
        },
        regCheck(e) {
            let val = e.target.value;
            let reg = /^\d+$|^\d+[.]?\d+$/
            let reTel = reg.test(val)
            if (reTel === false || val == 0) {
                this.$notify({
                    message: '房间数最少为1!',
                    type: 'danger',
                })
                this.roomNum = 1
            } else {
                this.roomNum = val
            } 
            this.peopleNum = this.roomNum
        },
        regCheck1(e) {
            let val = e.target.value;
            let reg = /^\d+$|^\d+[.]?\d+$/
            let reTel = reg.test(val)
            if (reTel === false || val == 0) {
                this.$notify({
                    message: '人数最少为1!',
                    type: 'danger',
                })
                this.peopleNum = 1
            } else {
                this.peopleNum = val
            } 
        },
        goOrder(e,hrtname,hrtid,showname,money,reservatcount){
            localStorage.removeItem("orderDetail")
            
            const params = {
                m: this.params.m,
                hotelid: this.params.hotelid,
                hotellname: this.hotelAllInfos.hotellname,
                hrtname: hrtname,
                hrtid: hrtid,
                showname: showname,
                dateRange: this.dateRangeNum,
                checkintime: this.initDate.startDate,
                checkouttime: this.initDate.endDate,
                money: money,
                reservatcount: reservatcount,
                hotelremark: this.hotelAllInfos.hotelremark
            }
            localStorage.setItem("orderInfo", JSON.stringify(params))
            let opts = { 
                m: this.params.m, 
                hotelid: this.params.hotelid
            }
            this.$router.push({
                path: '/hotelOrder',
                query: opts,
            })
        },
        swiperInits() {
          this.$nextTick(function() {
            var bannerSwiper = new Swiper('.room-banners', {
              autoplay: {
                delay: 5000,
                stopOnLastSlide: false,
                disableOnInteraction: true,
              },
              loop: true,
              pagination: {
                el: '.pagination',
              }
            })
          })
        },
        getRoomInfo(e,item){
            this.roomInfoShow = true
            this.roomInfos = item
            this.swiperInits()
        },
        closeRoomInfo(){
            this.roomInfoShow = false
        },  
        goMap() {
            console.log(this.headRess)
          if (this.isWeiXin()) {
            console.log(this.lats, 'this.lats')
            let lat = this.lats.lat
            let lng = this.lats.lng
            console.log(lat, lng, '21')
            this.headRess.ready().then(wx => {
              this.headRess.map(
                lat,
                lng,
                this.hotelAllInfos.hotellname,
                this.address
              )
              console.log(wx)
            })
          } else {
            window.location.href = `https://m.amap.com/search/mapview/keywords=${this.address}&cluster_state=5&pagenum=1`
          }
        },
        // goMap(){
        //     window.location.href = 'http://api.map.baidu.com/geocoder?address='+this.hotelAllInfos.hotellname+'&output=html&src=webapp.baidu.openAPIdemo'
        // },
        initMap(address) {
          let thisd = this
          var AMap = window.AMap
          new AMap.Map('mapContainer', {
            resizeEnable: true, //是否监控地图容器尺寸变化
            zoom: 12 //初始地图级别
          })
          AMap.plugin('AMap.Geocoder', function() {
            var geocoder = new AMap.Geocoder({
              // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
              // city: '010'
            })
            geocoder.getLocation(address, function(status, result) {
              // console.log(status, result, '++++')
              if (status === 'complete' && result.info === 'OK') {
                const { geocodes } = result
                // const { formattedAddress, location } = geocodes[0]
                const { location } = geocodes[0]
                const { lat, lng } = location
                thisd.lats = { lat, lng }
              }
            })
          })
        },
        //判断是否为微信访问
        isWeiXin() {
          //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
          var ua = window.navigator.userAgent.toLowerCase()
          //通过正则表达式匹配ua中是否含有MicroMessenger字符串
          if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            return true
          } else {
            return false
          }
        },
    },
    watch: {
        $route (to, from) {
            if(  to.query.hotelid !== from.query.hotelid){
                this.hotelid = to.query.hotelid;
                let opts = { 
                    m: this.params.m, 
                    hotelid: this.hotelid
                }
                this.hotelInsidePage(opts)
            }
        }
    },
}
</script>
<style lang="scss" scoped>
.hotel-banner .swiper-slide {
    position: relative;
    text-align: center;
}

.hotel-banner img {
    width: 100%;
    height: 450px;
    object-fit: cover;
}

.hotel-header {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 80px;
    background: none;
    display: flex;
    align-items: center;
    z-index: 10;

    .header-left,
    .header-right {
        width: 100px;
        height: 80px;
        text-align: center;
        .header-cricle {
            width: 60px;
            height: 60px;
            border-radius: 10px;
            margin: 10px auto 0;
            text-align: center;
            background: rgba(0, 0, 0, .3);

            img {
                width: 56%;
                height: 56%;
                margin-top: 22%;
            }
        }
    }

    .header-title {
        flex: 1;
        text-align: center;
        font-size: 30px;
    }
}

.hotelList_content {
    // .hotel-banner {
    //     width: 100%;
    //     height: 450px;

    //     .swiper-slide {
    //         width: 100%;
    //         height: 450px;
    //         img {
    //             width: 100%;
    //             height: 100%;
    //             object-fit: cover;
    //         }
    //     }
    // }
    .hotel-banners{
        overflow: hidden;
        width: 100%;
        height: 450px;
          .swiper-slide{
            position: relative;
            img{
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
        }
          
    }

    .hotel-detail-name {
        position: absolute;
        left: 0;
        right: 0;
        z-index: 10;
        font-size: 36px;
        color: #fff;
        padding: 10px 20px;
        margin-top: -80px;
        height: 60px;
        line-height: 60px;
        background: rgba(0,0,0,.4)
    }

    .hotel-wrap {
        background: #fffffffff;
        margin: 0 0 20px;
        padding: 10px 20px;
        display: flex;
        border-bottom: 1px solid #e2e8f0;
        .hotel-server{
            width: 100%;
            flex: 1;
            display: flex;
            color: #64748b;
        }
        .hotel-address {
            flex: 1;
            padding-right: 20px;
            font-size: 26px;
            line-height: 38px;
            p {
                color: #64748b;

                img {
                    width: 30px;
                    height: 30px;
                    vertical-align: -4px;
                }
            }

            p.hotal-syq {
                color: #1e293b;
                font-size: 30px;
                margin-bottom: 5px;
            }
            
        }
        .services {
            font-size: 26px;
            line-height: 38px;
            max-height: 48px;
            overflow: hidden;
        }
        .services-more{
            font-size: 26px;
            line-height: 38px;
        }
        .service-label{
            font-size: 30px;
            margin-top: 10px;
        }
        .service-text{
            display: flex;
            flex-wrap: wrap;
            span{
                display: block;
                width: 50%;
                margin-top: 5px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                img{
                    width: 40px;
                    margin-right: 3px;
                }
            }
        }
        .hotel-btn {
            width: 200px;
            color: #3b82f6;
            line-height: 46px;
            height: 46px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            img {
                width: 30px;
                height: 30px;
                vertical-align: -6px;
            }
            .hotel-tag{
                width: 38px;
                height: 38px;
                background: #3b82f6;
                border-radius: 19px;
                text-align: center;
                margin-right: 5px;
                img{
                    width: 26px;
                    height: 21px;
                    vertical-align: 5px;
                }
            }
        }
    }

    .hotel-list {
        position: relative;
        display: flex;
        padding: 0 20px 20px;
        margin-top: 20px;
        border-bottom: 1px solid #e2e8f0;
        .hotel-img{
            position: absolute;
            left: 15px;
            top: 0;
            bottom: 20px;
            width: 250px;
            border-radius: 10px;
            border: 1px solid #e2e8f0;
            overflow: hidden;
            img{
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .hotel-con {
            flex: 1;
            padding-left: 270px;

            .hotel-name {
                font-size: 32px;
                color: #1e293b;
                font-weight: bold;

                img {
                    width: 34px;
                    height: 34px;
                    vertical-align: -6px;
                }
            }

            .hotel-desc {
                font-size: 28px;
                color: #64748b;
                margin-top: 5px;
            }

            .hotel-lastnum {
                font-size: 24px;
                color: #f56c6c;
                margin-top: 5px;
            }

            .hotel-money {
                text-align: right;
                color: #64748b;
                padding-right: 15px;

                span {
                    color: #f56c6c;
                    font-size: 36px;
                    margin-right: 2px;
                }
            }

            .hotel-btn {
                width: 160px;
                height: 40px;
                background: #f56c6c;
                color: #fff;
                text-align: center;
                line-height: 40px;
                border-radius: 20px;
                float: right;
                margin-top: 5px;
            }
        }
    }

    .hotelNo {
        -webkit-filter: grayscale(100%);
        -moz-filter: grayscale(100%);
        -ms-filter: grayscale(100%);
        -o-filter: grayscale(100%);
        filter: grayscale(100%);
        filter: gray;
        filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
    }

    .hotel-text-tit {
        font-size: 34px;
        color: #1e293b;
    }

    .hotel-text {
        margin-top: 5px;
        color: #1e293b;
    }

    .hotel-detail-btn {
        display: flex;
        justify-content: space-between;

        .hotel-detail-index {
            line-height: 60px;
            color: #1e293b;
        }

        .hotel-detail-order {
            background: #f56c6c;
            color: #fff;
            width: 200px;
            height: 60px;
            text-align: center;
            line-height: 60px;
            font-size: 30px;
            border-radius: 10px;
        }
    }
    .hotel-wraps {
        background: #ffffff;
        margin-top: 20px;
        padding: 10px 20px;
        .guests-infos{
            width: 100%;
            padding: 15px 5px;
            font-size: 28px;
            background: #eff6ff;
            color: #1e293b;
            border-radius: 10px;
            .guests-info {
                display: flex;
                width: 100%;
                font-size: 28px;
                color: #1e293b;
                .guests-day {
                    flex: 1;
                    text-align: center;
                    input {
                        width: 100%;
                        text-align: center;
                    }

                    .rangediv{
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .rangedate {
                            padding: 0 15px;
                        }
                    }
                }

                .guests-number {
                    width: auto;
                    padding: 0 20px;
                    color: #1e293b;
                    text-align: center;
                    border-left: 1px solid #e2e8f0;
                    input{
                        width: 40px;
                        text-align: center;
                        border: none;
                    }
                }
            }
            
        }
        .guests-choose{
                padding: 0 20px;
                margin-top: 5px;
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                .choose-span{
                    width: 110px;
                    height: 40px;
                    background: #ffffff;
                    border-radius: 10px;
                    font-size: 24px;
                    text-align: center;
                    line-height: 40px;
                    border: 1px solid #e2e8f0;
                    margin-top: 10px;
                }
                .choose-span.roomActive{
                    background: #3b82f6;
                    color: #fff;
                }
            }
    }
    .hotel-rooms{
        margin-top: 20px;
        .hotel-text-tit{
            padding: 0 20px;
        }
        .hotel-list{
            position: relative;
            display: flex;
            padding: 15px;
            background: #fffffffff;
            margin-top: 20px;
            border-bottom: 1px solid #e2e8f0;
            .hotel-img{
                position: absolute;
                left: 15px;
                top: 15px;
                bottom: 15px;
                width: 250px;
                border-radius: 10px;
                border: 1px solid #e2e8f0;
                overflow: hidden;
                img{
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
            .hotel-con{
                width: 100%;
                padding-left: 270px;
                padding-top: 20px;
                .hotel-name{
                    font-size: 30px;
                    color: #1e293b;
                    font-weight: bold;
                }
                .hotel-desc{
                    font-size: 28px;
                    color: #1e293b;
                    margin-top: 5px;
                }
                .hotel-money{
                    text-align: right;
                    color: #1e293b;
                    padding-right: 15px;
                    font-size: 28px;
                    span{
                        color: #ff6600;
                        font-weight: bold;
                        i{
                            font-size: 40px;
                        }
                    }
                }
                .hotel-btn{
                    width: 120px;
                    height: 40px;
                    background-image: linear-gradient(135deg, #3b82f6, #6366f1);
                    color: #fff;
                    text-align: center;
                    line-height: 40px;
                    border-radius: 20px;
                    float: right;
                    margin-top: 5px;
                    padding: 0 5px;
                    span{
                        display: block;
                        float: left;
                        width: 100%;
                        text-align: center;
                        box-sizing: border-box;
                    }
                    // span:first-child{
                    //     border-right: 1px dashed #fff;
                    // }
                }
            }
        }
    }
    .hotel-room{
        .hotel-list{
            .hotel-con{
                .hotel-money{
                    color: #e6a23c;
                    display: flex;
                    align-items: flex-end;
                    justify-content: flex-end;
                    span{
                        line-height: 40px;
                    }
                    .room-btn{
                        width: 70px;
                        height: 70px;
                        background-image: linear-gradient(135deg, #3b82f6, #6366f1);
                        color: #fff;
                        font-size: 40px;
                        line-height: 70px;
                        text-align: center;
                        margin-left: 10px;
                    }
                }
            }
        }
    }
}

.room-ups{
    position: fixed;
    z-index: 101;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    .room-ups-bg{
        position: absolute;
        z-index: 102;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(0,0,0,.5)
    }
    .room-ups-close{
        position: absolute;
        z-index: 105;
        right: 30px;
        top: 30px;
        width: 50px;
        height: 50px;
        background: rgba(0,0,0,.4);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
            width: 65%;
            height: 65%;
        }
    }
    .room-ups-content{
        position: absolute;
        z-index: 103;
        left: 0;
        right: 0;
        top: 35%;
        bottom: 0;
        background: #ffffff;
        border-radius: 20px 20px 0 0;
        overflow: hidden;
        .room-banners .swiper-slide {
            position: relative;
            text-align: center;
        }
        .room-banners img {
            width: 100%;
            height: 400px;
            object-fit: cover;
        }
        .room-infos{
            padding: 20px;
            .room-infos-title{
                font-size: 34px;
                color: #1e293b;
            }
            .room-infos-con{
                display: flex;
                flex-wrap: wrap;
                font-size: 26px;
                color: #64748b;
                span{
                    width: 33.3%;
                    margin-top: 15px;
                }
            }
            .room-infos-notes{
                font-size: 26px;
                color: #64748b;
                margin-top: 20px;
                p{
                    margin-top: 5px;
                }
            }
        }
    }
}

</style>
<style type="text/css">
.pagination {
  position:absolute;
  z-index: 20;
  bottom: 10px;
  text-align:center;
  right: 0;
  left: 0;
  width: 100%;
}
.swiper-pagination-bullet {
  display:inline-block;
  width: 14px;
  height: 14px;
  border-radius: 14px;
  background:#fff;
  margin: 0 10px;
  opacity: 1;
  cursor:pointer;
}
.swiper-pagination-bullet-active {
  background: #3b82f6;
}
</style>